import { Link } from "react-router";

import { DATA_STORAGE_NOTICE, PRIVACY_POLICY_PATH } from "@/lib/legal";

/**
 * The standing data-storage disclaimer plus a link to the full privacy policy.
 * Renders a fragment, not a block, so each caller keeps its own typography; it
 * appears inside the footer, the signup form, the review step, and the results
 * gate.
 */
export function DataStorageNotice() {
  return (
    <>
      {DATA_STORAGE_NOTICE}{" "}
      <Link to={PRIVACY_POLICY_PATH} className="underline underline-offset-2 hover:no-underline">
        Read our privacy policy
      </Link>
      .
    </>
  );
}
